import React from 'react'
import { ANDROID_TITLE_DISPLAY_LENGTH } from 'scenes/CampaignCenter/Builder/pushCharLimits'

type Props = {
  appIcon: React.ReactNode
  appName: string
  title?: string | null
  body: string
  imageUrl?: string | null
  isExpanded: boolean
}

const Chevron: React.FC<{ up?: boolean }> = ({ up }) => (
  <span
    className={`push-android-notification__chevron ${
      up ? 'push-android-notification__chevron--up' : ''
    }`}
  >
    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" aria-hidden>
      <path
        d="M1 1.5L6 6.5L11 1.5"
        stroke="#3f4946"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </span>
)

// Android (Material You) lock-screen notification — Figma collapsed 38:3196 /
// expanded 38:3469. Collapsed: icon + title + one-line body + 48px thumbnail +
// expand chevron. On hover-expand: app name header, full body, full-bleed image.
const AndroidPushPreview: React.FC<Props> = ({
  appIcon,
  appName,
  title,
  body,
  imageUrl,
  isExpanded,
}) => {
  // Android truncates the notification title with an ellipsis well before iOS
  // does (~40 chars vs ~65), so the preview clips the title to mirror what an
  // Android device actually renders. The merchant can still type up to the iOS
  // cap; only the Android preview is clipped.
  const truncatedTitle =
    title && title.length > ANDROID_TITLE_DISPLAY_LENGTH
      ? `${title.slice(0, ANDROID_TITLE_DISPLAY_LENGTH)}…`
      : title
  const displayTitle = truncatedTitle || appName

  if (isExpanded) {
    return (
      <div className="push-android-notification push-android-notification--expanded">
        <div className="push-android-notification__content-row">
          <div className="push-android-notification__icon">{appIcon}</div>
          <span className="push-android-notification__app-name">{appName}</span>
          <Chevron up />
        </div>
        <p className="push-android-notification__title">{displayTitle}</p>
        <p className="push-android-notification__body">{body}</p>
        {imageUrl && (
          <img
            src={imageUrl}
            alt="notification attachment"
            className="push-android-notification__image"
          />
        )}
      </div>
    )
  }

  return (
    <div className="push-android-notification">
      <div className="push-android-notification__content-row">
        <div className="push-android-notification__icon">{appIcon}</div>
        <div className="push-android-notification__text">
          <p className="push-android-notification__title">{displayTitle}</p>
          <p className="push-android-notification__body push-android-notification__body--collapsed">
            {body}
          </p>
        </div>
        {imageUrl && (
          <img
            src={imageUrl}
            alt="notification thumbnail"
            className="push-android-notification__thumb"
          />
        )}
        <Chevron />
      </div>
    </div>
  )
}

export default AndroidPushPreview
